import React, {createContext, useContext, useState, useEffect} from "react";

const CartContext = createContext();

export const CartProvider = ({children}) => {
    const currentCart = JSON.parse(localStorage.getItem('cart'));

    const [cart, setCart] = useState(currentCart || []);

    const [total, setTotal] = useState(0);

    const addToCart = (item) => {
        setCart((prevCart) => [...prevCart, item]);
    }

    const updateCart = (updatedItem) => {
        setCart((prevCart) => {
            return prevCart.map((item) => {
                if (item.id === updatedItem.id)
                {
                    return updatedItem.qty > 0 ? {...item, qty: updatedItem.qty} : null;
                } else {
                    return item;
                }
            }).filter(item => item !== null);
        })
    }

    const clearCart = () => {
        setCart([]);
    }

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart));
    }, [cart]);

    return (
        <CartContext.Provider
        value={{ cart, total,
                addToCart, updateCart, setTotal, clearCart
        }}>
            {children}
        </CartContext.Provider>
    )
}

export const useCart = () => {
    return useContext(CartContext);
}